// AppShell.js
// Layout raiz para todas as rotas privadas.
//
// Estrutura (2026-05-10 — PageHeader removido):
//   Box flex row
//     AppSidebar (esquerda)
//     Box flex column
//       TopActionBar (sticky — agora inclui breadcrumbs à esquerda)
//       main (scroll)
//         PageActions (botões page-specific centralizados, sempre acima do search)
//         children (page content — geralmente abre com MainContainer.Search)
//
// AppSidebar no mobile vira overlay. O estado mobileOpen é gerenciado aqui
// porque o hamburguer está no TopActionBar (irmão) mas precisa abrir o
// Drawer do AppSidebar (irmão) — prop drilling simples, sem Redux.

import React, { useState } from 'react'
import Box from '@mui/material/Box'
import AppSidebar from './AppSidebar'
import TopActionBar from './TopActionBar'
import PageActions from './PageActions'
import { PageLayoutProvider } from './PageLayoutProvider'

export default function AppShell({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <PageLayoutProvider>
      <Box
        sx={{
          display: 'flex',
          minHeight: '100vh',
          bgcolor: 'background.default',
          // @media print: neutraliza flex/min-height para o <main> ocupar a folha
          // sem margens extras. Sidebar/TopActionBar/PageHeader cuidam da própria
          // ocultação via @media print no sx local de cada um (Drawer é portal,
          // então não dá pra esconder a partir daqui).
          '@media print': {
            display: 'block',
            minHeight: 0,
            bgcolor: 'transparent',
          },
        }}
      >
        {/* Sidebar — permanent desktop / temporary mobile */}
        <AppSidebar
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
        />

        {/* Right column: top bar + page header + scrollable content */}
        <Box
          component='div'
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0, // prevent flex overflow
            overflow: 'hidden',
            '@media print': {
              display: 'block',
              overflow: 'visible',
            },
          }}
        >
          {/* Global sticky actions bar (com breadcrumbs à esquerda) */}
          <TopActionBar onMobileMenuOpen={() => setMobileOpen(true)} />

          {/* Scrollable page content */}
          <Box
            component='main'
            sx={{
              flex: 1,
              overflowY: 'auto',
              pb: 8,
              '@media print': {
                overflow: 'visible',
                pb: 0,
              },
            }}
          >
            {/* Page-specific buttons (centralizados, sempre acima do search) */}
            <PageActions />
            {children}
          </Box>
        </Box>
      </Box>
    </PageLayoutProvider>
  )
}
